import { type FC } from "react";
import { LineAppModal } from "@userFrontend/features/publication/components/LineAppModal";
import { WebToAppPopUp } from "@userFrontend/features/publication/components/WebToAppPopUp";
import { ScoutReceivePopUp } from "@root/userFrontend/features/publication/components/ScoutReceivePopUp";

type Props = {
  isBiyo: boolean;
  lineAppModalProps: {
    isLogin: boolean;
    isShowLineFriendLink: boolean;
    isShowAppInstallLink: boolean;
  };
  bannerPattern: "webToApp" | "scoutReceive" | "lineApp";
};

export const BannersWrapper: FC<Props> = ({ isBiyo, lineAppModalProps, bannerPattern }) => {
  return (
    <>
      {(() => {
        switch (bannerPattern) {
          case "webToApp":
            return <WebToAppPopUp isBiyo={isBiyo} />;
          case "scoutReceive":
            return <ScoutReceivePopUp />;
          case "lineApp":
            return (
              <LineAppModal
                isBiyo={isBiyo}
                isLogin={lineAppModalProps.isLogin}
                isShowLineFriendLink={lineAppModalProps.isShowLineFriendLink}
                isShowAppInstallLink={lineAppModalProps.isShowAppInstallLink}
              />
            );
          default:
            return null;
        }
      })()}
    </>
  );
};
